var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DatePicker } from "../../ui/date.picker";
import { date } from "../../core/date";
import { helper } from "../../core/helper";
import { EventHandler } from "../../interaction/eventhandler";
var DateComponent = /** @class */ (function () {
    function DateComponent(options) {
        var _a;
        this.options = __assign({ enabled: true, id: helper.newDomGuid(), bindMode: "toModel" }, options);
        if (this.options.bindTo != null && this.options.property != null && this.options.value == null) {
            this.options.value = (((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toUI) ?
                this.options.converter.toUI(this.options.bindTo[this.options.property]) :
                this.options.bindTo[this.options.property]);
        }
        this.options.onChange = EventHandler.Create(this.options.onChange);
    }
    Object.defineProperty(DateComponent.prototype, "onChange", {
        get: function () {
            return this.options.onChange;
        },
        enumerable: false,
        configurable: true
    });
    DateComponent.prototype.render = function () {
        var _a;
        var val = this.options.value;
        if (this.options.bindMode !== "toModel" && this.options.bindTo != null && this.options.property != null) {
            var current = this.getValue();
            var newVal = (((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toUI) ?
                this.options.converter.toUI(this.options.bindTo[this.options.property]) :
                this.options.bindTo[this.options.property]);
            var newValStr = date.format(newVal);
            if (newValStr !== current) {
                val = newVal;
                if (this.currentDom != null) {
                    this.currentDom.value = newValStr;
                }
            }
        }
        return {
            tag: "input",
            attr: {
                id: this.options.id,
                class: this.options.class,
                style: this.options.style,
                disabled: !this.options.enabled ? "disabled" : undefined,
                placeholder: this.options.placeholder,
                value: date.format(val),
                change: this.raiseEvent,
            }
        };
    };
    DateComponent.prototype.getValue = function () {
        if (this.currentDom == null) {
            return "";
        }
        return this.currentDom.value;
    };
    DateComponent.prototype.getValueAsDate = function () {
        if (this.currentDom == null) {
            return null;
        }
        if (this.options.parse) {
            return this.options.parse(this.currentDom.value);
        }
        return date.parse(this.currentDom.value);
    };
    DateComponent.prototype.getRef = function () {
        return this.ref;
    };
    DateComponent.prototype.onCreate = function (node) {
        this.currentDom = node.dom;
        this.ref = DatePicker(this.currentDom, this.options);
    };
    DateComponent.prototype.onUpdate = function (node) {
        this.currentDom = node.dom;
    };
    DateComponent.prototype.onRemove = function () {
        if (this.ref != null) {
            this.ref.destroy();
        }
    };
    DateComponent.prototype.raiseEvent = function (e, node) {
        var _a;
        if (this.options.enabled) {
            var val = date.parse(node.dom.value);
            if (this.options.bindTo && this.options.bindMode !== "fromModel" && this.options.property) {
                this.options.bindTo[this.options.property] =
                    ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toData) ? this.options.converter.toData(val) : val;
            }
            this.options.onChange.notify(val);
        }
    };
    return DateComponent;
}());
export { DateComponent };
